export default __webpack_public_path__ + "marvel.abcbb3a0.png";